import { useEffect, useState } from "react";
import { Copy, FileUp, KeyRound, QrCode } from "lucide-react";
import { useBlobUrl } from "../../components/common";
import { ctraderRedirectUri } from "../Accounts";
import { NotificationSettings } from "./NotificationSettings";
import { api, errMsg } from "../../lib/api";

export default function AdminSettings() {
  const [s, setS] = useState(null);
  const [form, setForm] = useState({});
  const [msg, setMsg] = useState("");
  const [qrisVersion, setQrisVersion] = useState(0);
  const { url: qrisUrl } = useBlobUrl(s?.qris_uploaded ? `/qris?v=${qrisVersion}` : null);
  useEffect(() => { api.get("/admin/settings").then((r) => { setS(r.data); setForm({ usd_idr_rate: r.data.usd_idr_rate }); }); }, []);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e?.preventDefault();
    try {
      const body = Object.fromEntries(Object.entries(form).filter(([, v]) => v !== "" && v != null));
      if (body.usd_idr_rate) body.usd_idr_rate = Number(body.usd_idr_rate);
      const r = await api.put("/admin/settings", body);
      setS(r.data);
      setForm({ usd_idr_rate: r.data.usd_idr_rate });
      setMsg("Pengaturan tersimpan terenkripsi.");
    } catch (err) {
      setMsg(errMsg(err, "Gagal menyimpan pengaturan"));
    }
  };
  const uploadQris = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const body = new FormData();
    body.append("file", file);
    try {
      const r = await api.post("/admin/settings/qris", body);
      setS(r.data);
      setQrisVersion((v) => v + 1);
      setMsg("Gambar QRIS diperbarui.");
    } catch (err) {
      setMsg(errMsg(err, "Gagal mengunggah QRIS"));
    }
  };

  return (
    <>
      <div className="page-intro">
        <div><p className="eyebrow">ADMIN · INTEGRASI</p><h2>Integrasi & pembayaran</h2><p className="muted">Kredensial disimpan terenkripsi di server dan tidak pernah dikirim ke browser member.</p></div>
      </div>
      {msg && <div className="notice info" data-testid="admin-settings-message">{msg}</div>}
      <form className="integration-grid" onSubmit={save}>
        <div className="panel integration-card">
          <div className="panel-head"><div><p className="eyebrow">MT4 / MT5</p><h3>MetaApi platform token</h3></div><span className={s?.metaapi_configured ? "pill ok" : "pill warn"} data-testid="metaapi-config-status">{s?.metaapi_configured ? "Aktif" : "Pending"}</span></div>
          <p className="muted">Ambil token di app.metaapi.cloud/token. Setelah disimpan, akun member yang pending akan otomatis diprovisioning.</p>
          <label>Token MetaApi<input type="password" value={form.metaapi_token || ""} placeholder={s?.metaapi_configured ? "•••• tersimpan — isi untuk mengganti" : "Tempel token MetaApi"} onChange={set("metaapi_token")} data-testid="admin-metaapi-token-input" /></label>
          <label>Kurs USD → IDR (untuk tagihan sharing)<input type="number" min="1" value={form.usd_idr_rate || ""} onChange={set("usd_idr_rate")} data-testid="admin-usd-rate-input" /></label>
        </div>
        <div className="panel integration-card">
          <div className="panel-head"><div><p className="eyebrow">cTrader Open API</p><h3>Aplikasi OAuth</h3></div><span className={s?.ctrader_configured ? "pill ok" : "pill warn"} data-testid="ctrader-config-status">{s?.ctrader_configured ? "Aktif" : "Pending"}</span></div>
          <p className="muted">Daftarkan aplikasi di openapi.ctrader.com/apps dan tambahkan Redirect URI berikut:</p>
          <div className="copy-line" data-testid="ctrader-redirect-uri"><code>{ctraderRedirectUri()}</code><button type="button" className="icon-btn" onClick={() => navigator.clipboard?.writeText(ctraderRedirectUri())} data-testid="copy-redirect-uri"><Copy size={14} /></button></div>
          <label>Client ID<input value={form.ctrader_client_id ?? s?.ctrader_client_id ?? ""} onChange={set("ctrader_client_id")} data-testid="admin-ctrader-client-id-input" /></label>
          <label>Client Secret<input type="password" value={form.ctrader_secret || ""} placeholder={s?.ctrader_configured ? "•••• tersimpan — isi untuk mengganti" : "Client secret"} onChange={set("ctrader_secret")} data-testid="admin-ctrader-secret-input" /></label>
        </div>
        <div className="form-actions"><button className="primary" data-testid="admin-save-settings-button"><KeyRound size={15} /> Simpan pengaturan</button></div>
      </form>
      <NotificationSettings settings={s} form={form} set={set} onSave={save} />
      <section className="panel integration-card qris-admin mt">
        <div className="panel-head"><div><p className="eyebrow">PEMBAYARAN</p><h3>Gambar QRIS statis</h3></div><span className={s?.qris_uploaded ? "pill ok" : "pill warn"}>{s?.qris_uploaded ? "Terpasang" : "Belum ada"}</span></div>
        <div className="qris-admin-body">
          <div className="qris-frame small" data-testid="admin-qris-preview">{qrisUrl ? <img src={qrisUrl} alt="QRIS" /> : <QrCode size={40} />}</div>
          <div>
            <p className="muted">QRIS ini ditampilkan ke member saat checkout sewa EA dan pembayaran profit sharing.</p>
            <label className="upload"><FileUp size={18} /><span>Unggah gambar QRIS<input type="file" accept="image/*" onChange={uploadQris} data-testid="admin-qris-upload-input" /></span></label>
          </div>
        </div>
      </section>
    </>
  );
}
